import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { take} from 'rxjs/operators';
import { LinkAssetServiceService } from 'app/assets/service/link-asset-service.service';
import { IDropdown } from './../interfaces/model';

@Component({
  selector: 'app-quality-code-dialog',
  templateUrl: './quality-code-dialog.component.html',
  styleUrls: ['./quality-code-dialog.component.scss']
})

export class QualityCodeDialogComponent implements OnInit {
  dialogForm: FormGroup;
  reasons: IDropdown[] = [];
  constructor(private readonly fb: FormBuilder, readonly dialogRef: MatDialogRef<string>, private readonly linkAssetService: LinkAssetServiceService) {}

  ngOnInit() {
    this.dialogForm = this.fb.group({
      reason: ['', Validators.required],
    });

    this.linkAssetService.getQualityCodes().pipe(take(1)).subscribe(unlinkReasons => {
      if (unlinkReasons?.length){
        this.reasons = unlinkReasons.map(unlinkReason => {
          return {name: unlinkReason.name, value: unlinkReason.code };
        });
      }
    })
  }

  save(){
    const reason: IDropdown = this.reasons.find(reason => reason.name === this.dialogForm.value.reason);
    if (reason){
      this.dialogRef.close(reason.value);
    }
  }

  cancel(){
    this.dialogRef.close();
  }

}
